<template lang="pug">
.page.brand-new(ref="page")
  .inner-gap
    h2 The newest and greatest

    .filters-bar.mt-4
      .chips
        nuxt-link.chip(
          v-for="(i, k) in categories"
          :to="getLink(i)"
          :key="i.id"
          :class="{ active: isActive(i) }")
          span.name.pf-ellipsis(v-text="i.name")

    template(v-if="loading")
      .layout.flex.my-4(v-for="(tmp, k) in placeholders" :key="k")
        .aside
          BrandOverview
        .results
          ProductSlider(:products="placeholders")
    .template(v-else)
      infinite-fetcher(
        :fetch="getBrands"
        :paginator="paginator"
        loading-text="Loading more brand...")
        .layout.flex.my-4(v-for="brand in brands" :key="brand.id")
          .aside
            BrandOverview(:data="brand")
          .results
            ProductSlider(:products="brand.products")
        empty(
          v-if="!brands.length"
          title="No results found"
          type="empty.catalog")
        .ender
</template>

<script>
import BrandOverview from '~/components/catalog/BrandOverview'
import ProductSlider from '~/components/catalog/ProductSlider'
import InfiniteFetcher from '~/components/InfiniteFetcher.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BrandNew',

  components: {
    InfiniteFetcher,
    BrandOverview,
    ProductSlider
  },

  layout: 'catalog',

  data () {
    return {
      brands: [],
      loading: false,
      paginator: null,
      placeholders: Array.from({ length: 10 })
    }
  },

  fetch () {
    return this.getBrands().catch(this.$debug.log)
  },

  head () {
    return {
      title: 'New Brands'
    }
  },

  computed: {
    ...mapGetters({
      categories: 'master/productCategories',
      isLP: 'authentication/isLP'
    })
  },

  watch: {
    '$route.query': {
      handler (newQuery, oldQuery) {
        if (this._inactive || JSON.stringify(newQuery) === JSON.stringify(oldQuery))
          return

        this.$fetch()
      }
    }
  },

  methods: {
    isActive (category) {
      return +this.$route.query.category_id === category.id
    },

    getLink (category) {
      const query = this.isActive(category) ? {} : { category_id: category.id }

      return { query }
    },

    async getBrands (query, { clear = true } = {}) {
      this.loading = true

      const category = this.$route.query.category_id

      const res = await this.$api.catalog.searchBrands({
          ...query,
          'q[product_category_ids]': category || undefined,
          'q[new_brand]': true,
          per_page: 3
        },
        { role: this.isLP ? 'guest' : undefined })

      this.paginator = this.$paginators.parse(res)

      const brandsWithProducts = await Promise.all(res.results?.map(this.getProducts))

      this.brands = clear ? brandsWithProducts : this.brands.concat(brandsWithProducts)

      this.loading = false
    },

    getProducts (brand) {
      return this.$api.catalog.searchProducts({
        ...this.$route.query,
        brand_id: brand.id,
        per_page: 10,
        'q[new_product]': true
      }).then(({ results }) => ({ ...brand, products: results }))
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  gap: 30px;
  .aside {
    flex: 0 200px;
    @include media(sm-down) {
      display: none;
    }
  }
  .results {
    flex: 1;
    .page__shelf {
      .flex {
        gap: 12px;
        @include media(xs-only) {
          width: 100%;
        }
      }
    }
  }
}
.filters-bar {
  margin-bottom: 1em;
  .chips {
    display: flex;
    flex-wrap: wrap;
    .chip {
      background: white;
      font-size: 14px;
      line-height: 1em;
      padding: 6px 10px;
      border-radius: 1000px;
      white-space: nowrap;
      color: $--color-text-regular;
      margin-bottom: 10px;
      &:not(:last-child) {
        margin-right: 10px;
      }
      &.reset {
        background: white;
        border: 1px solid #e9edf1;
      }
      .name {
        max-width: 120px;
      }
      &.active {
        color: white;
        background: $--color-primary;
      }
    }
  }
}
</style>
